/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CoreLanguagePermissions } from './coreLanguagePermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CorePermissions { 
    language: CoreLanguagePermissions;
}
export const CorePermissions_language_Validators: ValidatorFn[] =
    [  Validators.required, ];


